module.exports = __webpack_public_path__ + "img/Slide28.064c982f.png";